import "./css/index.css";
import React from "react";
import classNames from "classnames";
import ODSColumn from "../ODSColumn/ODSColumn";
import { ODSDividerProps } from "./ODSDivider.types";

const ODSDivider: React.FC<ODSDividerProps> = ({
  variant = "vertical",
  type,
  inset = false,
  spacing = false,
  className,
  ...rest
}) => {
  const finalVariant = type ?? variant;
  if (type !== undefined && variant === undefined) {
    console.warn(
      "[ODSDivider] `type` is deprecated—please switch to `variant`."
    );
  }

  return (
    <ODSColumn
      className={classNames(
        `ODSDivider`,
        `ODSDivider--variant-${finalVariant}`,
        inset && `ODSDivider--inset`,
        spacing && `ODSDivider--spacing`,
        className
      )}
      {...rest}
    >
      <div
        className={classNames(
          "ODSDivider-rectangle",
          `ODSDivider-rectangle--variant-${finalVariant}`
        )}
      ></div>
    </ODSColumn>
  );
};

export default ODSDivider;
